import type { ReactNode } from 'react';

export const symbol_game_stick_l3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-786 380-919h200L480-786Zm241 429q99-52 99-125.92t-99-126Q622-661 480-661t-241 52.08q-99 52.08-99 126T239-357q99 52 241 52t241-52Zm-47 81v136q0 24.75-17.62 42.37Q638.75-80 614-80H345q-24.75 0-42.37-17.63Q285-115.25 285-140v-136q-92-31-148.5-85.51Q80-416.02 80-482.8 80-582 196.5-651 313-720 480-720t283.5 69.25Q880-581.51 880-483q0 67.24-56.5 122.12Q767-306 674-276ZM480-483Zm-33 103h87q6.22 0 10.11-4.5Q548-389 548-395t-4.5-10.5Q539-410 533-410h-71v-160q0-6-4.5-10.5T447-585q-6 0-10.5 4.5T432-570v175q0 6 4.5 10.5T447-380Z"
		/>
	</svg>
);
